//
// customGlyphs.js
//
// Extends the Vex.Flow.Font.glyphs with custom symbols
//
// (c) 2015 Greg Ristow, uTheory.com, all rights reserved
import { Font, Flow } from 'vexflow';
import type { FontData } from 'vexflow';

let font: Font;

export default function initGlyphs() {
  if (Flow.getMusicFont().includes('uTheory') && font) return font;

  const fontData: FontData = {
    resolution: 1000,
    glyphs: {
      xMark: {
        x_min: 0,
        x_max: 500,
        y_min: 0,
        y_max: 500,
        ha: 500,
        o: 'm -200 -248 l -75 2 l -200 252 l -100 252 l 0 52 l 100 252 l 200 252 l 75 2 l 200 -248 l 100 -248 l 0 -48 l -100 -248',
      },
      checkMark: {
        x_min: 0,
        x_max: 500,
        y_min: 0,
        y_max: 500,
        ha: 500,
        o: 'm -250 -113 l -176.26 -24.6 l -100 -88 l 173.2 185.2 l 250 112 l -100 -238',
      },
      missing: {
        x_min: 0,
        x_max: 500,
        y_min: 0,
        y_max: 500,
        ha: 500,
        o: 'm -250 52 l -175 52 l -175 -23 l 175 -23 l 175 52 l 250 52 l 250 -98 l -250 -98',
      },
      rightArrow: {
        x_min: 0,
        x_max: 500,
        y_min: 0,
        y_max: 500,
        ha: 500,
        o: 'm 250 -8 l -50 -258 l -50 -83 l -250 -83 l -250 67 l -50 67 l -50 242',
      },
      leftArrow: {
        x_min: 0,
        x_max: 500,
        y_min: 0,
        y_max: 500,
        ha: 500,
        o: 'm -250 -8 l 50 -258 l 50 -83 l 250 -83 l 250 67 l 50 67 l 50 242',
      },
      upArrow: {
        x_min: -250,
        x_max: 250,
        y_min: 0,
        y_max: 500,
        ha: 500,
        o: 'm 0 272 l -250 -28 l -75 -28 l -75 -228 l 75 -228 l 75 -28 l 250 -28 l 0 272',
      },
      downArrow: {
        x_min: -250,
        x_max: 250,
        ha: 500,
        o: 'm 0 -228 l -250 72 l -75 72 l -75 272 l 75 272 l 75 72 l 250 72',
      },
    },
  };

  font = Font.load('uTheory', fontData);
  if (!Flow.getMusicFont().includes('uTheory')) {
    Flow.setMusicFont(...Flow.getMusicFont(), 'uTheory');
  }
  return font;
}
